import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

export const FAQS = [
    {
        q: "Are your cables IS certified?",
        a: "We supply cables from established manufacturers whose builds follow IS 694, IS 1554 and IS 7098 as applicable, with IEC 60502 alignment on XLPE power cables. Ask for the specific product's documentation when you enquire.",
    },
    {
        q: "Do you supply custom lengths or cut reels?",
        a: "We cut to length from drum stock — order 90 m or 900 m and pay for what you pull. Cutting and dispatch timelines are confirmed when we quote; urgent jobs get priority.",
    },
    {
        q: "Which areas do you deliver to?",
        a: "We deliver across Bengaluru, Karnataka and South India, and arrange freight for project volumes anywhere in India. Delivery timelines are confirmed on your quotation.",
    },
    {
        q: "Do you provide test certificates and HSN codes?",
        a: "Invoices carry HSN codes and the applicable IS/IEC standard. Routine test certificates from the manufacturer can be provided — mention your documentation needs when you enquire.",
    },
    {
        q: "How does bulk or project pricing work?",
        a: "Share your BOQ and we return slab-wise pricing within one working day. Rates track LME copper, so project quotes are held for a fixed validity window.",
    },
    {
        q: "What are your payment and credit terms?",
        a: "New accounts start on advance or COD. Running credit terms open up after the first few orders — our desk will walk you through it on +91 900 81 77 176.",
    },
];

export default function FAQSection() {
    return (
        <section className="relative bg-paper py-20 lg:py-28" data-testid="faq-section">
            <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-12">
                <Reveal className="mb-10 text-center">
                    <Eyebrow className="mb-5 justify-center">10 — FAQ</Eyebrow>
                    <h2 className="font-display font-bold tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl text-ink">
                        Answers, <em className="text-copper">up front.</em>
                    </h2>
                </Reveal>

                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="border-t border-line">
                        {FAQS.map((f, i) => (
                            <AccordionItem key={i} value={`faq-${i}`} className="border-line" data-testid={`faq-item-${i}`}>
                                <AccordionTrigger className="text-left font-display font-semibold text-lg text-ink hover:text-copper py-5">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-mist text-sm leading-relaxed pb-5">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
